import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-16 pb-20 md:pt-24 md:pb-28 px-4 md:px-8 overflow-hidden bg-navy-dark" data-id="element-190">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-191"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-192">
        {/* Headline + Subtitle + Clarity */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16 md:mb-20" data-id="element-193">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-headline font-extrabold mb-8 md:mb-10 leading-[1.15] text-white text-glow max-w-4xl mx-auto text-center" data-id="element-194">
            ¿Sientes Que El Dinero Se Te Escapa Sin Importar Cuánto Trabajes?
          </h1>

          <p className="text-lg md:text-xl lg:text-2xl text-gold-light font-headline font-semibold leading-relaxed text-center max-w-3xl mx-auto" data-id="element-195">
            No es tu falta de capacidad. Es un programa subconsciente instalado
            antes de tus 7 años...
          </p>

          <p className="text-lg md:text-xl text-body font-body text-center max-w-2xl mx-auto mt-4" data-id="element-196">
            Descubre cómo la Neurociencia y la Fe pueden desinstalarlo en 7
            pasos.
          </p>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-3xl mx-auto mb-16 md:mb-20" data-id="element-197">
          <img src="https://cdn.magicpatterns.com/uploads/sbhjiicjXUXqHeyHURz1Uu/MOKAUP_PV_ROPMPE_CD.png" alt="Rompe El Código Del Dinero" className="w-full h-auto rounded-2xl shadow-soft box-glow relative z-0" data-id="element-198" />
        </motion.div>

        {/* Price + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-center flex flex-col items-center" data-id="element-199">
          <div className="flex flex-col items-center gap-4 mb-10" data-id="element-200">
            <span className="inline-block bg-gold-badge text-gold-light text-sm md:text-base font-headline font-bold px-5 py-2 rounded-full border border-gold/30 tracking-wide" data-id="element-201">
              🔥 83% DE DESCUENTO
            </span>
            <div className="flex items-center justify-center gap-4 md:gap-6" data-id="element-202">
              <span className="text-2xl md:text-3xl text-body line-through font-bold opacity-80" data-id="element-203">
                $37 USD
              </span>
              <span className="text-4xl md:text-5xl text-gold font-headline font-extrabold" data-id="element-204">
                → $6.36 USD
              </span>
            </div>
          </div>

          <CTAButton href="https://vitalyforms.com/cart/48329378398428:1" className="w-full md:w-auto mb-6" data-id="element-205">
            EMPIEZA HOY MISMO
          </CTAButton>

          <p className="text-sm md:text-base text-body/80 italic font-serif max-w-md" data-id="element-206">
            Una inversión menor que un café con leche… con impacto duradero en
            toda tu vida financiera
          </p>

          <p className="text-sm md:text-base text-gold-light font-headline font-semibold max-w-lg text-center mt-4" data-id="element-207">
            Estamos en fase de lanzamiento. Accede hoy al precio simbólico de
            $6.36 antes de que suba a $27.00 al finalizar la prueba de 48 horas.
          </p>
        </motion.div>
      </div>
    </section>;
}